.wrap { position: relative; display: inline-flex; }
.panel {
  position: absolute;
  z-index: 60;
  top: calc(100% + 6px);
  background: #fff;
  border: 1px solid var(--border-control);
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}
.right { right: 0; }
.left { left: 0; }
